<template>
  <div class="progress-wrapper" >
    <div class="container">
      <div class="progress-left">
<!--      <h5>{{completed}} out of {{total}} done</h5>-->

    </div>
    <div class="navigation">
      <div class="back" @click="$emit('prev')">
        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M21.4294 18.2136L15.0008 11.7851L8.57227 18.2136" stroke="#F3F6F9" stroke-width="1.81098" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div class="front" @click="$emit('next')">
        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M21.4294 11.7852L15.0008 18.2137L8.57227 11.7852" stroke="white" stroke-width="1.81098" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
export default {
name: "Progress",
  props: {
    // completed: {
    //   type: Number,
    //   default: 0
    // },
    // total: {
    //   type: Number
    // }
  }

}
</script>

<style lang="scss" scoped>
.progress-wrapper{

  z-index: 2;


  .progress-left{
    // margin-left: auto;

  }
  .container{
    display: flex;

     padding: 0px 4px;
  //flex-wrap: wrap;
  //grid-template-columns: 1fr 90px;
  column-gap: 10px;
  row-gap: 10px;
  padding: 10px 14px;
    justify-content: flex-end;
  }
  @media (max-width: 600px) {
    .progress-left{
      width: calc(100% - 96px) !important;
      h5{
        margin-bottom: 0;
      }
      .progress-bg{
        width: 100% !important;
      }
    }
  }

  .navigation{
    margin-top: auto;
    display: grid;
    width: 90px;
    height:40px;
    grid-template-columns: 40px 40px;
    grid-column-gap: 10px;
    .front,
    .back{
      display: flex;
      justify-content: center;
      align-items: center;
      height: 40px;
      width: 40px;
      background-color: #6a82fb;
      cursor: pointer;
      transition: all  0.2s ease-in-out;
      &:hover{
        box-shadow: 0 8px 12px 0 rgba(85, 126, 251, 0.75);

      }
    }
  }
}
</style>
